import React, { useMemo } from 'react';
import { ColorRepresentation } from 'three';

import { Polygon2D } from '@paragon/geometry-library';

import { convertFromLayoutToDesignCoordinates } from '../../../library/layout-geometry/coordinates';
import { ManySegment } from '../Segments';
import { FLAT_BEARING_Z_HEIGHT } from './BearingFlatVisual';
import { generateEnvelopeHatchLines, HatchingMode } from './generateEnvelopeHatchLines';

interface BearingHatchingProps {
  shape: Polygon2D;
  mode: HatchingMode;
  color: ColorRepresentation;
}

export function BearingHatching({ shape, mode, color }: BearingHatchingProps) {
  const segments = useMemo(() => {
    const hatchLines = generateEnvelopeHatchLines(shape, mode);

    return hatchLines.map((line) => {
      const start = convertFromLayoutToDesignCoordinates(line.basePoint.to3D(FLAT_BEARING_Z_HEIGHT)).toArray();
      const end = convertFromLayoutToDesignCoordinates(line.endPoint.to3D(FLAT_BEARING_Z_HEIGHT)).toArray();

      return { start, end };
    });
  }, [shape, mode]);

  const segmentsWithColor = useMemo(() => segments.map(({ start, end }) => ({ start, end, color })), [segments, color]);

  return segments.length === 0 ? null : <ManySegment segments={segmentsWithColor} />;
}
